import type { CandidateDetail } from '@/types/candidates';
import { CandidateAdditionalFieldsCard } from './candidate-additional-fields-card';
import { CandidateContactCard } from './candidate-contact-card';
import { CandidateCvPreviewStub } from './candidate-cv-preview-stub';
import { CandidateRecentNotes } from './candidate-recent-notes';
import { CandidateRecruiterCard } from './candidate-recruiter-card';
import { CandidateResponsibleRecruitersCard } from './candidate-responsible-recruiters-card';
import { CandidateSkillsCloud } from './candidate-skills-cloud';
import { CandidateTagsCloud } from './candidate-tags-cloud';
import { CandidateVacancyMatchCard } from './candidate-vacancy-match-card';

interface CandidateProfileContentProps {
  candidate: CandidateDetail;
}

export function CandidateProfileContent({ candidate }: CandidateProfileContentProps) {
  const activeAssignments = candidate.assignments.filter(
    (a) => a.result === 'IN_PROGRESS',
  );

  return (
    // The single-column track is spelled out on purpose: an implicit `auto` column is floored at
    // its content's min-content width, so below `lg` one long unbreakable string in any card used
    // to widen the whole page. The lg layout already had a 0-minimum first track.
    <div className="grid gap-6 grid-cols-[minmax(0,1fr)] lg:grid-cols-[minmax(0,1fr)_360px]">
      <div className="space-y-6">
        <CandidateContactCard candidate={candidate} />
        <CandidateAdditionalFieldsCard assignments={candidate.assignments} />
        <CandidateSkillsCloud candidate={candidate} />
        {activeAssignments.map((assignment) => (
          <CandidateVacancyMatchCard
            key={assignment.id}
            candidateId={candidate.id}
            vacancyId={assignment.vacancyId}
            vacancyTitle={assignment.vacancyTitle}
          />
        ))}
        <CandidateCvPreviewStub candidateId={candidate.id} />
      </div>
      <aside className="space-y-6">
        <CandidateTagsCloud candidate={candidate} />
        <CandidateRecentNotes candidateId={candidate.id} />
        <CandidateResponsibleRecruitersCard candidate={candidate} />
        <CandidateRecruiterCard
          creator={candidate.createdBy}
          createdAt={candidate.createdAt}
        />
      </aside>
    </div>
  );
}
